import { useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { formatApiError } from "@/lib/api";
import { cn } from "@/lib/utils";

export const REPAIR_STATUS = {
  new: ["Nouvelle", "tone-sky"], quoted: ["Devis reçu", "tone-butter"], accepted: ["Devis accepté", "tone-mint"],
  in_progress: ["En cours", "tone-peach"], done: ["Terminée", "tone-mint"], declined: ["Devis refusé", "tone-rose"],
  cancelled: ["Annulée", "tone-rose"], refused: ["Refusée par le pro", "tone-rose"],
};
export const CLAIM_STATUS = {
  submitted: ["Déclaré", "tone-sky"], under_review: ["En instruction", "tone-butter"], approved: ["Accepté", "tone-mint"],
  rejected: ["Refusé", "tone-rose"], paid: ["Indemnisé", "tone-mint"],
};

export const StatusChip = ({ map, status, testid }) => {
  const [label, tone] = map[status] || [status, "tone-sky"];
  return <span className={cn("tone-chip shrink-0 rounded-full px-2.5 py-0.5 text-xs font-semibold", tone)} data-testid={testid}>{label}</span>;
};

export const Thread = ({ messages = [], onSend, mine = "household", testid }) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    try { await onSend(text.trim()); setText(""); } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2" data-testid={testid}>
      {messages.length > 0 && (
        <ul className="max-h-60 space-y-2 overflow-y-auto">
          {messages.map((m) => (
            <li key={m.id} className={cn("max-w-[85%] rounded-2xl px-3 py-2 text-sm", m.side === mine ? "ml-auto bg-primary text-primary-foreground" : "bg-secondary")}>
              <div className="text-[11px] opacity-70">{m.author} · {new Date(m.at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}</div>
              {m.text}
            </li>
          ))}
        </ul>
      )}
      {onSend && (
        <form onSubmit={send} className="flex gap-2">
          <Input value={text} onChange={(e) => setText(e.target.value)} placeholder="Écrire un message…" maxLength={2000} data-testid={`${testid}-input`} />
          <Button type="submit" size="icon" className="shrink-0 rounded-full" disabled={busy} aria-label="Envoyer" data-testid={`${testid}-send`}><Send className="h-4 w-4" /></Button>
        </form>
      )}
    </div>
  );
};
